/*
 * <license header>
 */

import { Text } from "@adobe/react-spectrum";
import { register } from "@adobe/uix-guest";
import { extensionId } from "./Constants";
import metadata from '../../../../app-metadata.json';

function ExtensionRegistration() {
  const init = async () => {
    const guestConnection = await register({
      id: extensionId,
      metadata,
      methods: {
        headerMenu: {
          getButtons() {
            return [
              {
                'id': 'invoke-external-service',
                'label': 'Invoke External Service',
                'icon': 'Actions',
                onClick() {
                  guestConnection.host.modal.showUrl({
                    title: "Invoke External Service",
                    url: "/index.html#/invoke-service-modal",
                    width: 400,
                    height: 200,
                  });
                },
              },
            ];
          },
        },
      },
    });
  };
  init().catch(console.error);

  return <Text>IFrame for integration with Host (AEM)...</Text>
}

export default ExtensionRegistration;
